import { render, staticRenderFns } from "./TagTab.vue?vue&type=template&id=6d4948ac&"
import script from "./TagTab.vue?vue&type=script&lang=js&"
export * from "./TagTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports